export function prepareInventoryItem(row) {
    // Set default rental duration to 4 hours if not provided or invalid
    let rentalDuration = "4"; // Default value
    if (row.allowedTime && row.allowedTime.trim() !== '') {
        const duration = parseInt(row.allowedTime.trim(), 10);
        if (!isNaN(duration) && duration > 0) {
            rentalDuration = duration.toString();
        }
    }

    return {
        item: row.item || "",
        type: row.type || "",
        typeDescription: row.typeDescription || "",
        serialNo: row.serialNo || "",
        assetCondition: row.assetCondition || "",
        manufacturer: row.manufacturer || "",
        model: row.model || "",
        hyperlink: row.hyperlink || "",
        purchaseDate: row.purchaseDate || "",
        purchaseCost: row.purchaseCost || "",
        location: row.location || "",
        allowedTime: rentalDuration, // Use validated/default rental duration
        checkedOut: row.checkedOut === 'true',
        allowedClasses: row.allowedClasses || "",
        notes: row.notes || ""
    };
}